import {Alert, Box, Button, TextField, Typography} from '@mui/material';
import { useDispatch } from "react-redux";
import React, {ChangeEvent, FormEvent, useState} from "react";
import { InitialWorkDateConfirmation, InterfaceWorkDateConfirmation } from '../fielding.interface';
import moment from "moment/moment";
import AlertTitle from "@mui/material/AlertTitle";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {fieldingConfirmAssigned} from "../fielding.api";
import notificationError from "../../../shared/notificationError";
import notificationSuccess from "../../../shared/notificationSuccess";

export default function FieldingWorkDateConfirmation(props: { onClose: any, onValidate: any, fieldingRequestId: string, requestedStartDate: string, requestedEndDate: string }) {

    const dispatch = useDispatch<any>()

    const [values, setValues] = useState<InterfaceWorkDateConfirmation>(InitialWorkDateConfirmation)
    const [showPasswordC, setShowPasswordC] = useState(false)

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: value
        })
    }

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault()
        console.log({
            acceptedStartDate: moment(values.acceptedStartDate).toISOString(),
        })
        dispatch(fieldingConfirmAssigned({
            ...values,
            acceptedStartDate: moment(values.acceptedStartDate).toISOString(),
            acceptedEndDate: moment(values.acceptedEndDate).toISOString(),
            id: props.fieldingRequestId,
            isAccepted: true,
        }))
            .unwrap()
            .then((response: any) => {
                if (response.status === 200) {
                    props.onValidate()
                    notificationSuccess({})
                }
                else {
                    notificationError(response)
                }
            })
    }

    return (
        <Box>
            <form onSubmit={handleSubmit}>
                <Alert severity="warning" sx={{mb: 2}} iconMapping={{
                    warning: <CalendarMonthIcon fontSize="inherit" />,
                }}>
                    <AlertTitle>Recommended Work Date</AlertTitle>
                    {moment(props?.requestedStartDate).format("MM/DD/YYYY") + " - " + moment(props?.requestedEndDate).format("MM/DD/YYYY")}
                </Alert>
                <Typography variant={"h6"}>Enter your work date</Typography>
                <Typography>Please enter your start & end work date, we suggest to choose between recommended work date</Typography>
                <br />
                <Box display={"flex"} mb={2} gap={1} flexWrap={"wrap"}>
                    <TextField
                        type="date"
                        fullWidth
                        label="Start Date"
                        name="acceptedStartDate"
                        value={moment(values.acceptedStartDate).format("YYYY-MM-DD")}
                        onChange={handleChange}
                        sx={{ minWidth: "150px", marginTop: 1 }}
                    />
                </Box>
                <Box display={"flex"} gap={1} flexWrap={"wrap"}>
                    <TextField
                        type="date"
                        fullWidth
                        label="End Date"
                        name="acceptedEndDate"
                        value={moment(values.acceptedEndDate).format("YYYY-MM-DD")}
                        onChange={handleChange}
                        sx={{ minWidth: "150px", marginTop: 1 }}
                    />
                </Box>
                <br />
                <br />
                <Button type="submit" fullWidth variant="contained">
                    Confirm
                </Button>
            </form>
        </Box>
    )
}